module.exports = __webpack_public_path__ + "components/flag/static/square/un-2f7acca29d806987d88f0d16f67c87e0.svg";